export const ROBOT_TEXTS = {
  NEW_REQUESTS_HELPER:
    'This is where you define the user acces request, make sure to select "for myself" if you are requesting for your access only. Other users cannot be added in this option. Otherwise, select the other option.',
  USER_ID_NOT_FOUND:
    "Sorry, I can’t find your records. You may click HERE to report this feedback. Rest assured that this will be attended with urgency.",
  NEW_REQUEST_MULTIPLES_USERS_HELPER:
    "This option allows you to submit request for multiple users including yourself",
  INPUT_USER_ID: "Please input your User ID/Login ID.",
  USER_ID_REMINDER: "Don't forget to update the Login ID if it's incorrect.",
  USER_LOOKUP_HELPER:
    "Type in the email address and wait for the account suggestions to make sure that the user information exist.",
  WORKDAY_GSUITE_REMINDER:
    "Make sure that the GSuite and Workday accounts have been created. Type in the email address and wait for the account suggestions to ensure that the user information exist.",
  MISSING_INFORMATION:
    "Oops! There are missing information. Please ensure that you have updated all fields.",
  FINAL_STEP:
    "You're almost done! Kindly review your selection(s) and fill out required forms and fields.",
  SUMMARY: {
    SELECT_SYSTEM_HELPER:
      "You might now select the environment, role and access details. If you are not sure what to select, please contact your immediate supervisor",
  },
  SUCCESS_REQUEST: {
    HELPER:
      "Good news! You can now check the status of your request via chat.google.com Message @GearsBot to start a conversation. Thank you for using GEARS!",
  },
  SYSTEM_DETAILS_SCREEN_INITIAL_MESSAGE:
    "Search for the application / device type /domain account you would want to request. You may use the search box and filter options to easily find what you are looking for.",
  SYSTEM_INITIAL_MESSAGE:
    "You may now select the environment, role and add access details. If you are not sure what to select, please contact your immediate supervisor.",

  SYSTEM_MISSING_INFORMATION:
    "Oops! There are missing information. All fields are required so that the correct access will be granted.",
};

export const TEXTS = {
  CANCEL_CONFIRMATION:
    "Data will be removed, are you sure you want to cancel the request?",
  INPUT_LENGTH_1000_CHARS: "Must be at most 1000 characters",
  SUBMMIT_REQUEST_CONFIMARTION: "Are you sure you want to submit request?",
  SAVE_REQUEST_AS_DRAFT: "Are you sure you want to save request as draft?",
  DECLINE_ATTESTATION_CONFIRMATION:
    "Are you sure you want to cancel adding new request?",
};

export const GEARS_CONSTANTS = {
  DISCOVERY_DOCS: [
    "https://www.googleapis.com/discovery/v1/apis/admin/directory_v1/rest",
  ],
  GOOGLE_DIRECTORY_SCOPES:
    "https://www.googleapis.com/auth/admin.directory.user.readonly https://www.googleapis.com/auth/admin.directory.user https://www.googleapis.com/auth/drive",
};

//Select all the systems needed. Once done, the next page will show you the list of all the systems you have selected.
//You may now select the environment, role and add access details. If you are not sure what to select, please contact your immediate supervisor.
